/* Hauser MX — página "Vende tu propiedad" (Fase 11).
 *
 *   1. Tu zona ahora mismo → las pastillas pasan de anclas a filtro.
 *   2. Solicitud → el formulario nativo se responde en cuatro tramos.
 *   3. Salida por WhatsApp → compone el mensaje con lo ya respondido.
 *
 * ── PRINCIPIO ──────────────────────────────────────────────────────────────
 * Igual que en la fase 10: nada de aquí es necesario para usar la página. El
 * HTML llega completo y funcional desde Liquid — todos los municipios con sus
 * tarjetas, y el formulario entero enviable. Este archivo solo reorganiza lo
 * que ya está.
 *
 * Consecuencia práctica: **nada se oculta desde el CSS**. Los pasos se esconden
 * aquí, y solo después de que este código se hizo cargo de la navegación. Si
 * falla a mitad, lo peor que pasa es que se vea el formulario largo, que es el
 * estado que ya funcionaba.
 */
(function () {
  'use strict';

  var H = window.Hauser;
  var doc = document;

  /* ── 1. Zona: pastillas como filtro ───────────────────────────────── */

  function zona() {
    var sec = doc.querySelector('[data-hauser-vender-zona]');
    if (!sec) return;

    var pastillas = Array.prototype.slice.call(sec.querySelectorAll('.hauser-vzona__pastilla'));
    var grupos = Array.prototype.slice.call(sec.querySelectorAll('.hauser-vzona__grupo'));
    if (pastillas.length < 2 || grupos.length < 2) return;

    function activar(slug, mover) {
      var hay = false;
      grupos.forEach(function (g) {
        var on = g.getAttribute('data-municipio') === slug;
        if (on) { g.setAttribute('data-activo', ''); hay = true; }
        else g.removeAttribute('data-activo');
      });
      if (!hay) return false;

      pastillas.forEach(function (p) {
        var on = p.getAttribute('data-municipio') === slug;
        if (on) p.setAttribute('aria-current', 'true');
        else p.removeAttribute('aria-current');
      });

      if (mover) {
        /* Se mueve la SECCIÓN a la vista, no el grupo: al filtrar, el grupo
           pasa a ser lo único que hay, y saltar a él dejaría el encabezado y
           las pastillas fuera de pantalla. */
        try { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { sec.scrollIntoView(); }
      }
      return true;
    }

    /* Se enciende el filtro solo cuando ya hay un grupo activo: si algo falla
       antes, el CSS sigue mostrando los municipios uno tras otro. */
    var inicial = grupos.slice().sort(function (a, b) {
      return (parseInt(b.getAttribute('data-cuenta'), 10) || 0) - (parseInt(a.getAttribute('data-cuenta'), 10) || 0);
    })[0];
    if (!activar(inicial.getAttribute('data-municipio'), false)) return;
    sec.setAttribute('data-filtrando', 'true');

    pastillas.forEach(function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        activar(p.getAttribute('data-municipio'), true);
      });
    });
  }

  /* ── 2 y 3. Solicitud: pasos + WhatsApp ───────────────────────────── */

  /* Qué campo va en qué tramo. Se decide AQUÍ y no en el snippet del
     formulario, que lo comparte la página de Contacto y no sabe de pasos. */
  var PASOS = [
    { campos: ['operacion'], titulo: 'Qué quieres hacer' },
    { campos: ['tipo', 'zona'], titulo: 'Qué propiedad es' },
    { campos: ['m2', 'precio', 'mensaje'], titulo: 'Detalles' },
    { campos: ['nombre', 'telefono', 'email'], titulo: 'Cómo te contactamos' }
  ];

  function solicitud() {
    var sec = doc.querySelector('[data-hauser-solicitud]');
    if (!sec) return;

    var form = sec.querySelector('form');
    var contenedor = sec.querySelector('.hauser-form__campos');
    var enviar = sec.querySelector('.hauser-form__enviar');
    if (!form || !contenedor || !enviar) return;

    /* Tras un envío correcto, Shopify vuelve a pintar la sección con el
       mensaje de éxito y sin campos. No hay nada que trocear. */
    if (!contenedor.querySelector('[data-campo]')) return;

    var campos = {};
    Array.prototype.forEach.call(contenedor.querySelectorAll('[data-campo]'), function (el) {
      campos[el.getAttribute('data-campo')] = el;
    });

    /* Se arman solo los tramos que de verdad tienen campos en esta página. */
    var tramos = PASOS.map(function (p) {
      return { titulo: p.titulo, nodos: p.campos.map(function (c) { return campos[c]; }).filter(Boolean) };
    }).filter(function (p) { return p.nodos.length > 0; });
    if (tramos.length < 2) return;

    var actual = 0;

    /* --- avance --- */
    var avance = sec.querySelector('[data-avance]');
    var avActual = sec.querySelector('[data-avance-actual]');
    var avTotal = sec.querySelector('[data-avance-total]');
    var avBarra = sec.querySelector('[data-avance-barra]');
    if (avance) {
      avance.hidden = false;
      if (avTotal) avTotal.textContent = String(tramos.length);
    }

    /* --- navegación --- */
    var nav = doc.createElement('div');
    nav.className = 'hauser-solicitud__nav';

    var atras = doc.createElement('button');
    atras.type = 'button';
    atras.className = 'hauser-solicitud__atras';
    atras.textContent = '← Atrás';

    var siguiente = doc.createElement('button');
    siguiente.type = 'button';
    siguiente.className = 'hauser-boton-primario hauser-solicitud__siguiente';
    siguiente.textContent = 'Siguiente';

    var wa = doc.createElement('button');
    wa.type = 'button';
    wa.className = 'hauser-solicitud__wa';
    wa.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2Zm5.6 14.2c-.2.7-1.4 1.3-2 1.4-.5.1-1.2.1-1.9-.1a12 12 0 0 1-6.9-6c-.5-.9-.8-1.9-.8-2.7 0-1 .5-1.6.8-1.8.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2 0 .4-.1.6l-.4.5c-.1.1-.3.3-.1.6.2.4.8 1.3 1.7 2.1 1.1 1 2 1.3 2.3 1.4.2.1.4.1.6-.1l.7-.8c.2-.2.4-.2.6-.1l1.8.9c.2.1.4.2.4.3.1.2.1.6-.1 1.2Z"/></svg>' +
      '<span>Mandarlo por WhatsApp</span>';

    /* El botón nativo se mueve DENTRO de la navegación para que en el último
       tramo aparezca junto a la salida de WhatsApp, sin duplicar botones. */
    nav.appendChild(atras);
    nav.appendChild(siguiente);
    enviar.parentNode.insertBefore(nav, enviar);
    nav.appendChild(enviar);
    nav.appendChild(wa);

    function pintar(mover) {
      tramos.forEach(function (t, i) {
        t.nodos.forEach(function (n) { n.hidden = i !== actual; });
      });
      var ultimo = actual === tramos.length - 1;
      atras.hidden = actual === 0;
      siguiente.hidden = ultimo;
      enviar.hidden = !ultimo;
      wa.hidden = !ultimo;

      if (avActual) avActual.textContent = String(actual + 1);
      if (avBarra) avBarra.style.width = (((actual + 1) / tramos.length) * 100).toFixed(0) + '%';

      if (mover) {
        var primero = tramos[actual].nodos[0].querySelector('input, select, textarea');
        if (primero && primero.type !== 'radio') { try { primero.focus({ preventScroll: true }); } catch (e) { primero.focus(); } }
      }
    }

    /* Valida solo el tramo visible, apoyándose en el `required` que los campos
       ya traen del snippet: no se duplica aquí ninguna regla de validación. */
    function valido() {
      var ok = true;
      tramos[actual].nodos.forEach(function (n) {
        Array.prototype.forEach.call(n.querySelectorAll('input, select, textarea'), function (c) {
          if (!c.checkValidity()) {
            if (ok) c.reportValidity();
            ok = false;
          }
        });
      });
      return ok;
    }

    siguiente.addEventListener('click', function () {
      if (!valido()) return;
      if (actual < tramos.length - 1) { actual++; pintar(true); }
    });
    atras.addEventListener('click', function () {
      if (actual > 0) { actual--; pintar(true); }
    });

    /* Enter dentro de un campo avanza en vez de enviar a medio cuestionario. */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (t && t.tagName === 'TEXTAREA') return;
      if (actual < tramos.length - 1) {
        e.preventDefault();
        siguiente.click();
      }
    });

    /* --- WhatsApp: el mismo contenido, por el otro canal --- */
    function valor(clave) {
      var n = campos[clave];
      if (!n) return '';
      var marcado = n.querySelector('input[type="radio"]:checked');
      if (marcado) return marcado.value;
      var c = n.querySelector('input, select, textarea');
      return c ? String(c.value || '').trim() : '';
    }

    wa.addEventListener('click', function () {
      if (!valido()) return;

      var cfg = window.HauserRecorrido || {};
      var numero = String(cfg.numero || '').replace(/\D/g, '');
      if (!numero) return;   /* sin número configurado no se abre nada roto */

      var lineas = ['Hola, quiero información para ' + (valor('operacion') || 'vender').toLowerCase() + ' mi propiedad.'];
      var pares = [
        ['Tipo', valor('tipo')],
        ['Zona', valor('zona')],
        ['Metros cuadrados', valor('m2')],
        ['Precio que espero', valor('precio')],
        ['Nombre', valor('nombre')],
        ['Teléfono', valor('telefono')]
      ];
      pares.forEach(function (p) { if (p[1]) lineas.push(p[0] + ': ' + p[1]); });
      var extra = valor('mensaje');
      if (extra) lineas.push('', extra);

      window.open('https://wa.me/' + numero + '?text=' + encodeURIComponent(lineas.join('\n')), '_blank', 'noopener');
    });

    pintar(false);
  }

  /* ── arranque ─────────────────────────────────────────────────────── */

  function arrancar() {
    [zona, solicitud].forEach(function (fn) {
      try {
        fn();
      } catch (e) {
        if (window.console) console.warn('[Hauser] Vender, efecto con error:', e);
      }
    });
  }

  /* No depende del motor de movimiento: esto no es decoración, es la interfaz
     que convierte. Si `Hauser` no existe, igual tiene que funcionar. */
  if (H && typeof H.listo === 'function') H.listo(arrancar);
  else if (doc.readyState !== 'loading') arrancar();
  else doc.addEventListener('DOMContentLoaded', arrancar);
})();
